import { AuthProvider } from '@ankr.com/auth';

import { shrinkAddress } from 'modules/common/utils/shrinkAddress';
import { shrinkEmail } from 'modules/common/utils/shrinkEmail';

export interface GetAccountNameParams {
  address?: string;
  authProvider?: AuthProvider;
  email?: string;
  isOAuth: boolean;
  nickname?: string;
}

export const getAccountName = ({
  address,
  authProvider,
  email,
  isOAuth,
  nickname,
}: GetAccountNameParams) => {
  const shrinkedAddress = shrinkAddress(address);
  const shrinkedEmail = shrinkEmail(email);
  const shrinkedNickname = shrinkAddress(nickname);

  const isGoogle = authProvider === AuthProvider.Google;

  if (isOAuth) {
    return isGoogle ? shrinkedEmail : shrinkedNickname;
  }

  return shrinkedAddress;
};
